import React from 'react';

import {
  AboutHero,
  Aboutus,
  TestimonialSection,

} from '../components';

const About = () => {
  return (
    <div>
      <AboutHero />
      <Aboutus />
      <TestimonialSection />
    </div>
  );
};

export default About;
